<div class="buy" id="how-to-buy">
  <div class="container ">
    <div class="row">
      <div class="col-12 col-lg-12 text-center">
        <h1 class="fw-bold heading text-uppercase">{{"buy-heading" | translate}}</h1>
        <p class="font-18 py-4">{{"buy-para" | translate}}</p>
      </div>
    </div>
    <div class="row align-items-center mt-5 justify-content-between mt-3">
      <div class="col-12 col-lg-4">
        <img src="/assets/images/svg-icons/buy.svg" alt="" class="img-fluid">
      </div>
      <div class="col-12 col-lg-7">
        <div class="box text-left mt-3" *ngFor="let item of items">
          <h1 class="font-24 text-white">{{item.head | translate}}</h1>
          <p class="font-16">{{item.para | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
